import { graphql } from '../../graphql';

export const getKeywordsByPath = graphql(`
  query KeywordsByPath($path: Path!) {
    keywords(filter: { path: $path }) {
      ...KeywordFields
    }
  }
`);
